import { useEffect, type FC } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { useOutsideAlerter } from 'shared/hooks'
import { NAME_INBOX } from 'entities/Inbox'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { MenuCardInbox } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuCard/MenuCardInbox/MenuCardInbox'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import styles from '../MenuCardInboxGroup/ui/styles.module.scss'
import { MenuCardInput } from '../MenuCardInput/MenuCardInput'

type IMenuCardInboxGroupCreateProps = {
  item: GroupInbox
}

export const MenuCardInboxGroupCreate: FC<IMenuCardInboxGroupCreateProps> = observer(
  ({ item: groupInbox }) => {
    const store = useConversationMenuContext()
    const { inboxesStore } = useEntitiesContext()
    const { deleteItemTree, groupsApiMenuStore } = store
    const { onUpdateTeamsGroupsCreate, loadingCreateGroupTeam } = groupsApiMenuStore

    const groupInboxes = () => {
      return groupInbox.teamsIds.reduce<Inbox[]>((state, teamId) => {
        const inbox = inboxesStore.getItem(teamId)

        if (!(inbox instanceof Inbox)) return state
        if (groupInbox.isFavoriteType !== inbox.isFavoriteType) return state

        state.push(inbox)

        return state
      }, [])
    }
    const groupTeams = groupInboxes()
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        deleteItemTree(NAME_INBOX.Create)
      }
    }

    const { ref } = useOutsideAlerter(() => {
      deleteItemTree(NAME_INBOX.Create)
    })

    useEffect(() => {
      window.addEventListener('keyup', onKeyUp)

      return () => {
        window.removeEventListener('keyup', onKeyUp)
      }
    }, [])

    return (
      <div ref={ref} className={classnames(styles.wrap)}>
        <div
          className={classnames(styles.wrapGroup, {
            [styles.disabled]: loadingCreateGroupTeam,
          })}
        >
          <div className={classnames(styles.boxName, styles.boxName__input)}>
            <div className={styles.icon}>
              <IconButton
                icon={groupInbox.icon}
                size={'small'}
                color={'transparent'}
                fontSize={16}
                ariaLabel='MenuCardInbox_create'
              />
            </div>

            <MenuCardInput
              onKeyUp={(e) => {
                const target = e.target

                if (target instanceof HTMLInputElement) {
                  if (e.key === 'Enter' && target.value.length) {
                    onUpdateTeamsGroupsCreate(target.value, groupInbox)
                  }
                }
              }}
            />
          </div>
        </div>

        <div>
          {groupTeams.map((inbox) => {
            return <MenuCardInbox key={inbox.id} item={inbox} groupInbox={groupInbox} isCreate />
          })}
        </div>
      </div>
    )
  }
)
